import { MemeIndex } from "./memeIndex";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../index";

export async function getMemeUrl(memeIndex) {
    const url = await getDownloadURL(ref(storage, `${MemeIndex[memeIndex]}`));
    return url;
}